import { Component } from 'react';
import { connect } from 'react-redux'
import { hashHistory } from "react-router"
import { saveRedirectURL } from './../../actions';

class AppSecureContainer extends Component {

  componentDidMount() {

    let currentURL = this.props.currentURL

    if (this.props.isLoggedIn === false ) {
       switch (this.props.currentURL)  {
         case "/logout":
         case "/login":
           currentURL = "/"
           break;
        default:
           //do nothing
           break;
       }

       this.props.dispatch(saveRedirectURL(currentURL))
       hashHistory.push("/login")
    }

  }

  render() {

    if (this.props.isLoggedIn) {
      return this.props.children
    } else {
      return (
        null
      )
    }
  }
}


function mapStateToProps(state, ownProps) {
  return {
    isLoggedIn: state.isLoggedIn,
    currentURL: ownProps.location.pathname
  }
}

export default connect(mapStateToProps)(AppSecureContainer)



// WEBPACK FOOTER //
// ./src/components/App/AppSecureContainer.js